import PropTypes from "prop-types";

/**
 *
 * @param {string} width
 * @param {string} height
 * @param {string} fill
 * @returns {JSX.Element}
 * @constructor
 */
export default function Plus({ height = '10', width = '10', fill = 'none' }) {
    return (
        <svg width={width} height={height} viewBox="0 0 10 10" fill={fill} xmlns="http://www.w3.org/2000/svg">
            <path d="M0 5H10" stroke="black" stroke-width="2"/>
            <path d="M5 10L5 -2.98023e-07" stroke="black" stroke-width="2"/>
        </svg>
    )
}

Plus.PropTypes = {
    width: PropTypes.string,
    height: PropTypes.string,
    fill: PropTypes.string,
}
